// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__281UF","rootNoMargin":"styles_rootNoMargin__171Dc"};